// Autogenerated locales - do not modify
/* tslint:disable quotemark variable-name */
export const AUTOMATIC_COMMENT_VIOLATES_RULES = "Nahlas nevhodnou odpov\u011bd";
export const DELETE = "Vyma\u017e";
export const FORUM_COMMENT_EDIT_MENU = "Uprav";
export const FORUM_COMMENT_MOVE_UP = "Posunout odpov\u011b\u010f nahoru";
export const SEND_HEART_TO_username = "Po\u0161li srd\u00ed\u010dko %(username)s";
export const SHOW_USERS_WHO_LIKED_THIS_POST = "Zobraz u\u017eivatelky, kter\u00fdm se to l\u00edb\u00ed";
